import Vue from 'vue';
import CustomerReviews from './CustomerReviews.vue';
import PaymentForm from './PaymentForm.vue';
import SubscriptionPlan from './SubscriptionPlan.vue';

Vue.component('paywall-subscription-plan', SubscriptionPlan)
Vue.component('paywall-payment-form', PaymentForm)
Vue.component('paywall-customer-reviews', CustomerReviews)
